import React from 'react';
import { useTranslation } from 'react-i18next';

const HomePage = () => {
  const { t } = useTranslation();
  
  return (
    <div className="min-h-screen bg-soft-white dark:dark-bg-primary">
      {/* Hero Section */}
      <div className="max-w-7xl mx-auto container-padding py-20">
        <div className="text-center">
          <h1 className="text-display-xl font-bold text-charcoal dark:dark-text-primary mb-6">
            {t('home.welcomeTitle')}
          </h1>
          <p className="text-body-lg text-charcoal-light dark:dark-text-secondary mb-12 max-w-2xl mx-auto">
            {t('home.welcomeSubtitle')}
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <a href="/activities" className="btn-primary btn-lg">
              {t('home.exploreActivities')}
            </a>
            <a href="/register" className="btn-secondary btn-lg">
              {t('home.getStarted')}
            </a>
          </div>
        </div>
      </div>

      {/* Features Section */}
      <div className="bg-white dark:bg-dark-bg-secondary py-20">
        <div className="max-w-7xl mx-auto container-padding">
          <div className="text-center mb-16">
            <h2 className="text-display-lg font-bold text-charcoal dark:dark-text-primary mb-4">
              {t('home.whyChooseLudus')}
            </h2>
            <p className="text-body-md text-charcoal-light dark:dark-text-secondary max-w-2xl mx-auto">
              {t('home.whyChooseSubtitle')}
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Feature 1 */}
            <div className="text-center p-6">
              <div className="w-16 h-16 bg-ludus-orange/10 dark:bg-dark-ludus-orange/10 rounded-2xl flex items-center justify-center mx-auto mb-6">
                <span className="text-3xl">🎯</span>
              </div>
              <h3 className="text-body-lg font-semibold text-charcoal dark:dark-text-primary mb-3">
                {t('home.curatedExperiences')}
              </h3>
              <p className="text-body-md text-charcoal-light dark:dark-text-secondary">
                {t('home.curatedExperiencesDesc')}
              </p>
            </div>

            {/* Feature 2 */}
            <div className="text-center p-6">
              <div className="w-16 h-16 bg-ludus-orange/10 dark:bg-dark-ludus-orange/10 rounded-2xl flex items-center justify-center mx-auto mb-6">
                <span className="text-3xl">💳</span>
              </div>
              <h3 className="text-body-lg font-semibold text-charcoal dark:dark-text-primary mb-3">
                {t('home.securePayments')}
              </h3>
              <p className="text-body-md text-charcoal-light dark:dark-text-secondary">
                {t('home.securePaymentsDesc')}
              </p>
            </div>

            {/* Feature 3 */}
            <div className="text-center p-6">
              <div className="w-16 h-16 bg-ludus-orange/10 dark:bg-dark-ludus-orange/10 rounded-2xl flex items-center justify-center mx-auto mb-6">
                <span className="text-3xl">📱</span>
              </div>
              <h3 className="text-body-lg font-semibold text-charcoal dark:dark-text-primary mb-3">
                {t('home.mobileOptimized')}
              </h3>
              <p className="text-body-md text-charcoal-light dark:dark-text-secondary">
                {t('home.mobileOptimizedDesc')}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div className="bg-ludus-orange dark:bg-dark-ludus-orange py-20">
        <div className="max-w-7xl mx-auto container-padding text-center">
          <h2 className="text-display-lg font-bold text-white mb-6">
            {t('home.readyToStartAdventure')}
          </h2>
          <p className="text-body-lg text-white/90 mb-8 max-w-2xl mx-auto">
            {t('home.readyToStartDesc')}
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <a href="/activities" className="btn-secondary btn-lg bg-white text-ludus-orange hover:bg-warm">
              {t('home.browseActivities')}
            </a>
            <a href="/partner-registration" className="btn-outline btn-lg border-white text-white hover:bg-white hover:text-ludus-orange">
              {t('home.becomePartner')}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePage;